import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { productBrand } from "../productBrand";

type ProductWordmarkProps = {
  height?: string;
};

const ProductWordmark: React.FC<ProductWordmarkProps> = ({
  height = "1.5rem",
}) => {
  const theme = useTheme();

  if (productBrand.usesImageWordmark) {
    return (
      <Box
        component="img"
        src={
          theme.palette.mode === "dark"
            ? productBrand.wordmarkLightSrc
            : productBrand.wordmarkDarkSrc
        }
        alt={productBrand.name}
        sx={{
          height,
          width: "auto",
          display: "block",
        }}
      />
    );
  }

  return (
    <Typography
      component="span"
      sx={{
        fontFamily: productBrand.wordmarkFontFamily,
        fontWeight: 700,
        fontSize: height,
        lineHeight: 1,
        color: "text.primary",
        letterSpacing: "-0.02em",
      }}
    >
      {productBrand.name}
    </Typography>
  );
};

export default ProductWordmark;
